// components/compliance/PurposeOfUseBanner.jsx
import React from "react";

/**
 * HIPAA Purpose of Use Banner
 * Documents the reason for accessing PHI data and the access time.
 *
 * @param {string} purpose - The purpose of accessing the data (e.g., "Payment Processing for Services & Mileage Reimbursement")
 */
const PurposeOfUseBanner = ({ purpose = "Payment Processing" }) => {
  return (
    <div className="alert alert-info py-2 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <span>
          <strong>Purpose of Use:</strong> {purpose}
        </span>
        <span>
          <strong>Access Time:</strong> {new Date().toLocaleString()}
        </span>
      </div>
    </div>
  );
};

export default PurposeOfUseBanner;
